module.exports = __webpack_public_path__ + "img/1508876426.db16f0c5.jpg";